import { useState, useRef, useEffect } from "react";
import alpha_ess_smile_g3_s5 from "../../../assets/alpha-ess-smile-g3-s5.png";
import "../KeyBenefits.css";
import triangle_yellow from "../../../assets/triangle_yellow.png";

const features = [
  { title: "All-in-One System", description: "Integrated 5kW hybrid inverter and battery in a sleek, space-saving design" },
  { title: "Expandable Capacity", description: "Start with 10.1kWh and expand up to 60.5kWh as your energy needs grow" },
  { title: "Built-in UPS Backup", description: "Automatic power during outages with built-in changeover switch functionality" },
  { title: "VPP & Fast FCAS Ready", description: "Participate in Virtual Power Plants and grid services to earn additional income" },
  { title: "All-in-One System", description: "Integrated 5kW hybrid inverter and battery in a sleek, space-saving design" },
  { title: "Expandable Capacity", description: "Start with 10.1kWh and expand up to 60.5kWh as your energy needs grow" },
];

const images = [alpha_ess_smile_g3_s5, alpha_ess_smile_g3_s5, alpha_ess_smile_g3_s5, alpha_ess_smile_g3_s5];

export default function KeyBenefits() {
  const [activeIndex, setActiveIndex] = useState(0);
  const sectionRef = useRef(null);
  const [inView, setInView] = useState(false);

  useEffect(() => {
    const el = sectionRef.current;
    if (!el) return;
    const obs = new IntersectionObserver(
      ([e]) => setInView(e.isIntersecting),
      { threshold: 0.2 }
    );
    obs.observe(el);
    return () => obs.disconnect();
  }, []);

  return (
    <div ref={sectionRef} className={`benefits-proven-brands-section ${inView ? "benefits-in-view" : ""}`}>
      <div className="benefits-brands-content">
        <div className="benefits-image-and-dots">
          <div className="benefits-image-row">
            <img key={activeIndex} src={images[activeIndex]} alt="Modern home with solar battery system" className="benefits-brands-image" />
          </div>
          <div className="benefits-dots">
            {[0, 1, 2, 3].map((i) => (
              <button
                key={i}
                type="button"
                className={`benefits-dot ${i === activeIndex ? "active" : ""}`}
                onClick={() => setActiveIndex(i)}
                aria-label={`Show image ${i + 1}`}
                aria-pressed={i === activeIndex}
              />
            ))}
          </div>
        </div>
        <div className="benefits-brands-info-card">
          <h2>Key Benefits & Features</h2>
          {features.map((f, i) => (
            <div key={i} className="benefits-feature-row">
              <div className="benefits-feature-icon">
                <img src={triangle_yellow} alt="Arrow Icon" className="arrow-icon" />
              </div>
              <div className="benefits-feature-text">
                <h3>{f.title}</h3>
                <p>{f.description}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
